const ClassMode = {
  Teacher: 'Teacher',
  Student: 'Student',
  Guest: 'guest',
};

export default ClassMode;
